import { ThemeProvider } from "@portal/providers/themeProvider";
import useTheme from "./use-theme";

interface LocalThemeProviderProps {
  children: React.ReactNode;
}

function LocalThemeProvider(props: LocalThemeProviderProps) {
  const { config } = useTheme();
  return <ThemeProvider theme={config}>{props.children}</ThemeProvider>;
}

export { LocalThemeProvider };
